









































  import Vue from 'vue'
  import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
  import moment from 'moment'
  import InputWithValidation from '@/mixins/InputWithValidation'
import { dateWeekFormat } from '@/filters/dateFormat'

  @Component
  export default class DateRangePicker extends Mixins(InputWithValidation) {
    @Prop() private label!: string
    @Prop() private start!: Date
    @Prop() private end!: Date
    @Prop() private disabled!: boolean
    @Prop({ default: false })
    public clearable!: boolean

    @Prop({ default: '' })
    public rules!: string

    private windowModal = false
    private windowValues: string[] = []

    /*
     * Gestion du modèle via le datepicker.
     */
    @Watch('start')
    private onStartChanged() {
      this.setWindowValues()
    }

    @Watch('end')
    private onEndChanged() {
      this.setWindowValues()
    }

    private setWindowValues() {
      const format = 'YYYY-MM-DD'
      this.windowValues = []

      if (this.start && moment(this.start).year() > 1900) {
        this.windowValues.push(moment(this.start).format(format))
      }
      if (this.end && moment(this.end).year() > 1900) {
        this.windowValues.push(moment(this.end).format(format))
      }
    }

    @Watch('windowValues', { deep: true })
    private onWindowValuesChanged(newValue: string[], oldValue: string[]) {
      if (!oldValue || newValue.join() !== oldValue.join()) {
        if (this.windowValues.length === 2) {
          this.$emit(
            'update:start',
            moment(this.windowValues.sort()[0]).toDate()
          )
          this.$emit('update:end', moment(this.windowValues.sort()[1]).toDate())
          this.$emit('blur')
          this.windowModal = false
        }
      }
    }

    /*
     * Gestion du modèle via la textbox.
     */
    private get windowText(): string {
      return this.windowValues.join(' ~ ')
    }

    private setWindowText(event: any) {
      if (event.currentTarget.value) {
        this.windowValues = this.getWindow(event.currentTarget.value)
      } else {
        this.$emit('update:start', undefined)
        this.$emit('update:end', undefined)
      }

      this.$emit('blur')
    }

    /**
     * Récupère une fenêtre de temps si le texte d'entrée est sous le format "YYYY-MM-DD (*) YYYY-MM-DD"
     * ou un tableau vide sinon.
     */
    private getWindow(text: string): string[] {
      const dates = text.match(/([0-9]{4}-[0-9]{2}-[0-9]{2})/g)
      if (dates != null && dates.length === 2) {
        const date1 = new Date(dates[0])
        const date2 = new Date(dates[1])
        if (!isNaN(date1.getTime()) && !isNaN(date2.getTime())) {
          return [
            date1.toISOString().split('T')[0],
            date2.toISOString().split('T')[0]
          ].sort()
        }
      }
      return []
    }

    public get windowWeeks() {
      return this.windowValues.length === 2
        ? `${dateWeekFormat(this.windowValues[0])} ~ ${dateWeekFormat(this.windowValues[1])}`
        : ''
    }
  }
